export default function registerFunctions(factory) {
	// Functions
	factory.register(require('./server-sent-events'));
	factory.register(require('./session-message'));
	factory.register(require('./trigger-evaluate'));
}